import clsx from 'clsx'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
// import {HeaderNotificationsMenu, HeaderUserMenu, Search} from '../../../partials'
import { useLayout } from '../../core'
import { useAuth } from "../../../../app/modules/auth";
import { color } from "chart.js/helpers";
import { useEffect, useMemo, useState } from 'react';
import axios from 'app/infrastructure/axiosInstance';
import * as config from 'app/configs/configs';
import { WebPushNotificationsProvider } from 'app/infrastructure/WebPushNotificationProvider';
import Notifications from 'app/partials/view/Notifications';
import Notification from 'app/models/Notification';

const itemClass = 'ms-1 ms-lg-3'
const btnClass =
    'btn btn-icon btn-custom w-35px h-35px w-md-40px h-md-40px'
// const userAvatarClass = 'symbol-35px symbol-md-40px'
const btnIconClass = 'svg-icon-1'

const baseApiUrl = config.getBaseApiUrl();

const Navbar = () => {
    const { config } = useLayout();
    const { logout } = useAuth();
    const [notifications, setNotifications] = useState<Notification[]>([]);
    const [showNotifications, setShowNotifications] = useState<boolean>(false);

    const notificationCount = useMemo(() => {
        return notifications.filter((notification) => !notification.read_at).length;
    }, [notifications]);

    const logoutAction = () => {
        logout();
        document.location.reload();
    };

    async function getNotifications() {
        const notifications = await WebPushNotificationsProvider.getAll()
        const notificationsParsed = notifications.map((notification) => ({
            ...notification,
            data: JSON.parse(notification.data as string)

        }));
        setNotifications(notificationsParsed);
    }


    useEffect(() => {
        getNotifications();
        setInterval(() => {
            getNotifications();
        }, 10000);
    }, []);

    return (
        <div className='app-navbar flex-shrink-0'>
            {/*<div className={clsx('app-navbar-item align-items-stretch', itemClass)}>*/}
            {/*<Search />*/}
            {/*</div>*/}

            {/*<div className={clsx('app-navbar-item', itemClass)}>*/}
            {/*<div*/}
            {/*data-kt-menu-trigger="{default: 'click'}"*/}
            {/*data-kt-menu-attach='parent'*/}
            {/*data-kt-menu-placement='bottom-end'*/}
            {/*className={btnClass}*/}
            {/*>*/}
            {/*<KTSVG path='/media/icons/duotune/general/gen022.svg' className={btnIconClass} />*/}
            {/*</div>*/}
            {/*<HeaderNotificationsMenu />*/}
            {/*</div>*/}

            {/*<div className={clsx('app-navbar-item', itemClass)}>*/}
            {/*<div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>*/}
            {/*<KTSVG path='/media/icons/duotune/communication/com012.svg' className={btnIconClass} />*/}
            {/*<span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />*/}
            {/*</div>*/}
            {/*</div>*/}

            {/*<div className={clsx('app-navbar-item', itemClass)}>*/}
            {/*<ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />*/}
            {/*</div>*/}

            <div className={clsx('app-navbar-item', itemClass)}>
                <div id='tp-notifies' className={btnClass} style={{ position: "relative" }}>
                    <div onClick={() => {
                        setShowNotifications(true);
                        setTimeout(() => {
                            WebPushNotificationsProvider.markAllRead();
                        }, 1000);
                    }}>
                        <div style={{ position: "relative" }}>
                            <i className="fa-solid fa-bell fs-lg-1" style={{ color: "#FFF" }}>
                            </i>
                            {(notificationCount > 0) &&
                                <div style={{
                                    position: "absolute",
                                    top: "-10px",
                                    right: "-10px",
                                    backgroundColor: "#DC143C",
                                    borderRadius: "50%",
                                    width: "20px",
                                    height: "20px",
                                    color: "#FFF",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    fontSize: "12px"
                                }}>
                                    {notificationCount}
                                </div>
                            }
                        </div>

                    </div>
                    <div style={{
                        position: "absolute",
                        width: "300px",
                        height: "200px",
                        top: "50px",
                        left: "-150px",
                        backgroundColor: "#FFF",
                        borderRadius: "10px",
                        display: showNotifications ? "block" : "none",
                        boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.75)"
                    }}>
                        <Notifications notifications={notifications} close={() => setShowNotifications(false)} />
                    </div>
                </div>
            </div>

            <div className={clsx('app-navbar-item tp-logout-wrapper', itemClass)} style={{ borderLeft: 0 }}>
                <div
                    className={clsx('cursor-pointer symbol')}
                    data-kt-menu-trigger="{default: 'click'}"
                    data-kt-menu-attach='parent'
                    data-kt-menu-placement='bottom-end'
                >
                    <a onClick={logoutAction} className='menu-link px-5 tp-logout'>
                        <strong>Logout</strong>
                    </a>
                </div>
            </div>

            {config.app?.header?.default?.menu?.display && (
                <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
                    <div
                        className='btn btn-icon btn-active-color-primary w-35px h-35px'
                        id='kt_app_header_menu_toggle'
                    >
                        <KTSVG path='/media/icons/duotune/text/txt001.svg' className={btnIconClass} />
                    </div>
                </div>
            )}
        </div>
    )
}

export { Navbar }
